import { Installation } from 'src/Libs/installations/models'
import { ChargingLocationModel } from '../models'

/* E3DC office osnabruck */
const DEFAULT_LAT = 52.27701187
const DEFAULT_LNG = 8.05142498

type chargingLocationQueryKey = [string, string, number]

/**
 * return the query key for fetching charging location.
 * used for react-query caching.
 * Note: if installationId is undefined, this query is disabled. (see useFetchChargingLocation.tsx)
 * but we still need to  return a default query key.
 */
export const fetchChargingLocationQueryKey = (installationId: number | undefined): chargingLocationQueryKey => {
  /* sending a default query key */
  if (!installationId) return ['vehicle-integration', 'charging-location', 0]

  return ['vehicle-integration', 'charging-location', installationId]
}

/**
 * Get the initial charging location
 * Default location is E3DC office osnabruck.
 */
export const getCurrentChargingLocation = (
  chargingLocation: ChargingLocationModel | null,
  installation: Installation | undefined
): ChargingLocationModel => {
  /* first check charging location from vehicle database */
  const hasChargingLocation = chargingLocation?.gpsLatitude && chargingLocation?.gpsLongitude

  if (hasChargingLocation) return chargingLocation

  /* otherwise check location from installation */
  const hasInstallationLocation = installation?.gpsLatitude && installation?.gpsLongitude

  if (hasInstallationLocation) {
    const installationLocation: ChargingLocationModel = { gpsLatitude: installation.gpsLatitude, gpsLongitude: installation.gpsLongitude }
    return installationLocation
  }

  /* else return default location */
  const defaultChargingLocation: ChargingLocationModel = { gpsLatitude: DEFAULT_LAT, gpsLongitude: DEFAULT_LNG }

  return defaultChargingLocation
}
